import http from '@/api/common'

export default {
  // Command
  upsertBusiness(data) {
    return http.post('Business/Upsert', data)
  },
  upsertBusinessUser(data) {
    return http.post('Business/ModifyUsers', data)
  },
  upsertBusinessNote(data) {
    return http.post('Business/UpsertNote', data)
  },
  upsertBusinessDocument(data, config) {
    return http.post('Business/AddDocument', data, config)
  },
  upsertBusinessInfo(data) {
    return http.post('Business/UpsertInfo', data)
  },
  upsertBusinessPromotion(data) {
    return http.post('Business/UpsertPromotion', data)
  },
  upsertBusinessBilling(data) {
    return http.post('Business/UpsertBilling', data)
  },
  upsertBusinessDiscount(data) {
    return http.post('Business/UpsertDiscount', data)
  },
  upsertDiscountProductAdd(data) {
    return http.post('Business/UpsertDiscountProductAdd', data)
  },
  swapShop(data) {
    return http.post('saintgobain/swapshopid', data)
  },
  setBusinessStatus(data) {
    return http.post('Business/SetBusinessStatus', data)
  },
  resetUserPassword(data) {
    return http.post('User/ResetPassword', data)
  },
  getDownloadToken(data) {
    return http.post('User/GetDownloadToken', data)
  },
  // Query
  getBusinesses(data) {
    return http.get('BusinessQuery/Registered', data)
  },
  getBusinessLocation(sid) {
    return http.get(`BusinessQuery/Location?key=${sid}`)
  },
  getBusinessInfo(sid) {
    return http.get(`BusinessQuery/Info?key=${sid}`)
  },
  getBusinessPromotion(sid) {
    return http.get(`BusinessQuery/Promotion?key=${sid}`)
  },
  getBusinessUsers(sid) {
    return http.get(`BusinessQuery/Users?key=${sid}`)
  },
  getBusinessNotes(sid) {
    return http.get(`BusinessQuery/Notes?key=${sid}`)
  },
  getBusinessBilling(sid) {
    return http.get(`BusinessQuery/Billing?key=${sid}`)
  },
  getBusinessDiscounts({ sid, type, other }) {
    return http.get(`BusinessQuery/Discounts?key=${sid}&type=${type}&other=${other}`)
  },
  getBusinessDiscountsProductAdds({ sid }) {
    return http.get(`BusinessQuery/DiscountsProductAdds?key=${sid}`)
  },
  lookupBusiness(search) {
    return http.get(`business/LookupBusiness?search=${search}`)
  },
  getRoles(type) {
    return http.get(`BusinessQuery/Roles?type=${type}`)
  },
  searchBusinesses(search) {
    return http.get('BusinessQuery/Search', {
      params: search
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/business.js